export const DROPDOWN_TYPE = {
  CHECKLIST: 'checklist',
  ICON_LIST: 'icon_list',
  DEFAULT: 'default',
  AVATAR: 'avatar',
}

export const MULTI_LOCATION_GROUP_DROPDOWN = {
  MULTI_GROUP_DROPDOWN: 'multiGroupDropdown',
}

export const DROPDWON_SEARCH_FIELD_NAME = 'dropdown-search'
